// extracted by mini-css-extract-plugin
module.exports = {"code-validation":"OtpValidation_code-validation__c2hCn"};